import { render, staticRenderFns } from "./EventListView.vue?vue&type=template&id=3944be29"
import script from "./EventListView.vue?vue&type=script&lang=js"
export * from "./EventListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports